const FamilyTreeFill = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 .75a1.875 1.875 0 0 0-.75 3.593v.907h-3a1.5 1.5 0 0 0-1.5 1.5v.532a1.875 1.875 0 0 0 0 3.435v.533H3a1.5 1.5 0 0 0-1.5 1.5v.908a1.875 1.875 0 1 0 1.5 0v-.908h3v.908a1.875 1.875 0 1 0 1.5 0v-.908a1.5 1.5 0 0 0-1.5-1.5h-.75v-.533a1.875 1.875 0 0 0 0-3.435V6.75h7.5v.532a1.875 1.875 0 0 0 0 3.435v.533H12a1.5 1.5 0 0 0-1.5 1.5v.908a1.875 1.875 0 1 0 1.5 0v-.908h3v.908a1.875 1.875 0 1 0 1.5 0v-.908a1.5 1.5 0 0 0-1.5-1.5h-.75v-.533a1.875 1.875 0 0 0 0-3.435V6.75a1.5 1.5 0 0 0-1.5-1.5h-3v-.907A1.875 1.875 0 0 0 9 .75Zm0 1.125a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM4.5 8.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm9 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM2.25 14.625a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm4.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm4.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm4.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default FamilyTreeFill;
